import {createReducer, on} from "@ngrx/store";
import {ISharedPermissionsStoreState} from "./shared-permissions.state";
import {SharedPermissionsActions} from "@shared/stores/permissions/store/shared-permissions.actions-type";

export const initialState: ISharedPermissionsStoreState = {
  packages: [],
  userPermissions: [],
  userFeatureFlags: {},
  loading: false,
  loaded: false
};

export const sharedPermissionsStore = createReducer(
  initialState,
  on(SharedPermissionsActions.getPermissions, (state, {}) => ({
    ...state,
    isLoading: true
  })),
  on(SharedPermissionsActions.getPermissionsSuccess, (state, { packages, userPermissions, userFeatureFlags }) => ({
    ...state,
    packages,
    userPermissions,
    userFeatureFlags,
    isLoading: false,
    loaded: true
  }))
);

